import { useEffect } from 'react';
import { useAuth } from '../context/AuthContext';

export const useCipSSO = () => {
  const { loginWithToken } = useAuth();

  useEffect(() => {
    const handleMessage = (event) => {
      // Validar origen - solo aceptar mensajes de dominios autorizados
      const allowedOrigins = [
        'http://localhost:5173',
        'https://ciphuanuco.org.pe',
        'https://www.ciphuanuco.org.pe',
        'https://cip.sistemasudh.com'  // ⬅️ AGREGAR ESTA LÍNEA
      ];

      if (!allowedOrigins.includes(event.origin)) {
        return;
      }

      // Verificar que sea el mensaje correcto
      const data = event.data;
      if (data.type !== 'CIP_AUTH_DATA') {
        return;
      }

      try {
        // Guardar directamente en localStorage primero (por si acaso)
        localStorage.setItem('auth_token', data.sso_token);
        
        // Autenticar con el token SSO
        const userData = {
          id: data.user.id,
          name: data.user.nombre,
          email: data.user.email,
          role: 'cliente', // FORZAR rol cliente para que pueda hacer reservas
          dni: data.user.dni,
          origen: 'cip'
        };
        
        localStorage.setItem('user', JSON.stringify(userData));
        loginWithToken(data.sso_token, userData);
      } catch (error) {
        console.error('❌ Error al autenticar con token SSO:', error);
      }
    };

    window.addEventListener('message', handleMessage);

    // Cleanup al desmontar
    return () => {
      window.removeEventListener('message', handleMessage);
    };
  }, [loginWithToken]);
};